import { CardsGrid } from "../Card";
import { ShimmerCard } from "./ShimmerCard";

export const CardSkeleton = ({
  showBody = true,
  showMetadata = true,
  showTags = true,
}: {
  showBody?: boolean;
  showMetadata?: boolean;
  showTags?: boolean;
}) => {
  return (
    <CardsGrid>
      {Array.from({ length: 6 }, (_, index) => (
        <ShimmerCard
          key={index}
          showBody={showBody}
          showMetadata={showMetadata}
          showTags={showTags}
        />
      ))}
    </CardsGrid>
  );
};
